document.addEventListener("DOMContentLoaded", function () {

  document.addEventListener("click", function (event) {
    const boton = event.target.closest(".boton-cotizar-product-card");
    if (!boton) return; // Si no se hizo clic en un botón relevante, salir

    const productCard = boton.closest(".product-item");
    if (!productCard) return;

    const titleElement = productCard.querySelector(
      ".card-title.link-underline .text"
    );
    const title = titleElement?.textContent?.trim() || "Producto sin título";

    const variantInput = productCard.querySelector(
      'form[action="/cart/add"] input[name="id"]'
    );
    const productId = variantInput?.value || "ID desconocido";

    //console.log("Producto a cotizar:", { title, productId });

    showCotizacionModal(title, productId);
  });

  function showCotizacionModal(title, id) {
    const product = {
      title: title,
      id: id,
    };

    document.documentElement.classList.add("remove-scrolling");

    const modalHTML = `
    <div class="formulario-cotizacion-dulox-modal-overlay visible" id="cotizacionModalOverlay">
      <div class="formulario-cotizacion-dulox-modal">
        <button class="formulario-cotizacion-dulox-cerrar" aria-label="Cerrar">×</button>
        <h2 class="formulario-cotizacion-dulox-titulo">Solicita una cotización</h2>
        <p class="formulario-cotizacion-dulox-subtitulo">
          Completa tus datos para recibir una cotización personalizada del producto 
          <strong class="product-title-cotizacion">${product.title}</strong>
        </p>
        
        <form id="formularioCotizacionDulox" class="formulario-cotizacion-dulox-form">
          <input type="hidden" name="productId" value="${product.id}">
          <input type="hidden" name="productTitle" value="${product.title}">
          <input type="hidden" name="clienteId" value="${
            window.clienteShopifyID || "Cliente sin cuenta o sesión iniciada."
          }">

          <div class="formulario-cotizacion-dulox-campo-group">
            <div class="formulario-cotizacion-dulox-campo">
              <label for="cotizacionNombre">Nombre Completo*</label>
              <input type="text" id="cotizacionNombre" name="nombre" maxlength="100" required minlength="4" maxlength="255" placeholder="Ej: Juan Pérez">
            </div>
            <div class="formulario-cotizacion-dulox-campo">
              <label for="cotizacionEmpresa">Empresa*</label>
              <input type="text" id="cotizacionEmpresa" name="empresa" maxlength="100" required maxlength="255" placeholder="Ej: Mi Empresa S.A.">
            </div>
          </div>

          <div class="formulario-cotizacion-dulox-campo-group">
            <div class="formulario-cotizacion-dulox-campo">
              <label for="cotizacionCorreo">Correo Electrónico*</label>
              <input type="email" id="cotizacionCorreo" maxlength="100" name="email" required placeholder="Ej: juan@email.com">
            </div>
            <div class="formulario-cotizacion-dulox-campo">
              <label for="cotizacionTelefono">Teléfono*</label>
              <input id="telefono" type="tel" id="cotizacionTelefono" name="telefono" maxlength="14" required placeholder="Ej: +56912345678">
            </div>
          </div>

          <div class="formulario-cotizacion-dulox-campo">
            <label for="cotizacionDireccion">Dirección*</label>
            <input id="cotizacionDireccion" type="text" maxlength="200" name="direccion" required placeholder="Ej: Av. Principal 123, Santiago"></input>
          </div>

          <div class="formulario-cotizacion-dulox-campo">
            <label for="cotizacionCantidad">Cantidad*</label>
            <div class="formulario-cotizacion-dulox-cantidad">
              <button type="button" class="quantity__button" name="minus">-</button>
              <input type="number" id="cotizacionCantidad" name="cantidad" value="1" min="1" max="10000" required class="quantity__input">
              <button type="button" class="quantity__button" name="plus">+</button>
            </div>
          </div>

          <div class="formulario-cotizacion-dulox-campo">
            <label for="cotizacionMensaje">Mensaje adicional (Opcional)</label>
            <textarea id="cotizacionMensaje" name="mensaje" maxlength="1000" rows="4" placeholder="Detalles adicionales para tu cotización"></textarea>
          </div>
          
          <!-- reCaptcha -->
          <div class="g-recaptcha" data-sitekey="6Ld1vVArAAAAAEt-hzqqtIqKm1bDEw-gPzQnyBn-"></div>

          <div class="formulario-cotizacion-dulox-botones">
            <button type="button" class="formulario-cotizacion-dulox-cancelar">Cancelar</button>
            <button type="submit" class="formulario-cotizacion-dulox-boton">
              Enviar Solicitud
            </button>
          </div>
        </form>
      </div>
    </div>
    `;

    document.body.insertAdjacentHTML("beforeend", modalHTML);

    // reCaptcha
    setTimeout(() => {
      // Ensure the reCAPTCHA API has loaded before trying to render
      if (typeof grecaptcha !== "undefined") {
        grecaptcha.render(document.querySelector(".g-recaptcha"), {
          sitekey: "6Ld1vVArAAAAAEt-hzqqtIqKm1bDEw-gPzQnyBn-",
        });
      } else {
        console.error("reCAPTCHA API not loaded!");
        // Optionally, you could try to reload the script here if needed
      }
    }, 100);

    const overlay = document.getElementById("cotizacionModalOverlay");
    const closeBtn = document.querySelector(
      ".formulario-cotizacion-dulox-cerrar"
    );
    const cancelBtn = document.querySelector(
      ".formulario-cotizacion-dulox-cancelar"
    );

    function closeModal() {
      overlay.classList.remove("visible");
      document.documentElement.classList.remove("remove-scrolling");
            if (typeof grecaptcha !== "undefined") {
        grecaptcha.reset();
      }
      setTimeout(() => {
        overlay.remove();
      }, 300);
    }

    if (closeBtn) closeBtn.addEventListener("click", closeModal);
    if (cancelBtn) cancelBtn.addEventListener("click", closeModal);

    const quantityInput = document.querySelector(".quantity__input");
    const minusBtn = document.querySelector('button[name="minus"]');
    const plusBtn = document.querySelector('button[name="plus"]');

    if (minusBtn && plusBtn && quantityInput) {
      minusBtn.addEventListener("click", () => {
        let value = parseInt(quantityInput.value);
        if (value > 1) quantityInput.value = value - 1;
      });
      plusBtn.addEventListener("click", () => {
        let value = parseInt(quantityInput.value);
        quantityInput.value = value + 1;
      });
    }

    const telefonoInput = document.getElementById("telefono"); // Asegúrate de que el ID del campo de teléfono sea 'telefono'.

    telefonoInput.addEventListener("input", function () {
      // Elimina cualquier espacio y deja solo números
      this.value = this.value.replace(/\D/g, ""); // Reemplaza todo lo que no sea número
    });

    const form = document.getElementById("formularioCotizacionDulox");
    const submitBtn = form.querySelector("button[type='submit']");

    form.addEventListener("submit", async function (e) {
      e.preventDefault();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const formData = new FormData(form);
      const data = Object.fromEntries(formData.entries());

      // Validaciones personalizadas
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const telefonoRegex = /^\d{8,14}$/;

      const nombre = data.nombre.trim();
      const empresa = data.empresa.trim();
      const direccion = data.direccion.trim();
      const mensaje = data.mensaje?.trim() || "";
      const cantidad = parseInt(data.cantidad);

      if (!emailRegex.test(data.email)) {
        alert("Por favor ingresa un correo electrónico válido.");
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
        return;
      }

      if (!telefonoRegex.test(data.telefono)) {
        alert(
          "El teléfono debe contener solo números y tener entre 8 y 14 dígitos."
        );
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
        return;
      }

      if (nombre.length < 4 || nombre.length > 100) {
        alert("El nombre debe tener entre 4 y 100 caracteres.");
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
        return;
      }

      if (empresa === "" || empresa.length < 2 || empresa.length > 100) {
        alert(
          "Por favor ingresa el nombre de tu empresa (mínimo 2 caracteres)."
        );
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
        return;
      }

      if (direccion === "" || direccion.length < 4 || direccion.length > 200) {
        alert(
          "Por favor ingresa una dirección válida (entre 4 y 200 caracteres)."
        );
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
        return;
      }

      if (isNaN(cantidad) || cantidad < 1 || cantidad > 10000) {
        alert("La cantidad debe ser un número entre 1 y 10,000.");
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
        return;
      }

      if (mensaje.length > 1000) {
        alert("El mensaje adicional no puede superar los 1000 caracteres.");
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
        return;
      }

  // Validación Google reCAPTCHA v2
  const recaptchaResponse = grecaptcha.getResponse();
  if (!recaptchaResponse) {
    alert("Por favor completa el verificador de seguridad");
    return;
  }

      // Desactivar botón y mostrar ícono de carga
      submitBtn.disabled = true;
      const originalText = submitBtn.innerHTML;
      submitBtn.innerHTML = `
        <svg class="loading-icon" style="margin: 0 auto; width: 20px; height: 20px;" width="24" height="24" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none">
          <g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">
            <path d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8" opacity=".2"/>
            <path d="M7.25.75A.75.75 0 0 1 8 0a8 8 0 0 1 8 8 .75.75 0 0 1-1.5 0A6.5 6.5 0 0 0 8 1.5a.75.75 0 0 1-.75-.75"/>
          </g>
        </svg>
      `;

      try {
        formData.append("g-recaptcha-response", recaptchaResponse);
        const response = await fetch(
          "https://paleturquoise-curlew-987337.hostingersite.com/DuloxAPI/cotizacion_dulox.php",
          {
            method: "POST",
            body: formData,
          }
        );

        const result = await response.json();

        if (result.success) {
                if (typeof grecaptcha !== "undefined") {
        grecaptcha.reset();
      }
          closeModal();
          mostrarModalExito();
        } else {
                if (typeof grecaptcha !== "undefined") {
        grecaptcha.reset();
      }
          alert("" + result.error);
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalText;
        }
      } catch (error) {
              if (typeof grecaptcha !== "undefined") {
        grecaptcha.reset();
      }
        console.error("Error al enviar el formulario:", error);
        alert("Hubo un problema al enviar la solicitud. Intenta más tarde.");
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
    });

    function mostrarModalExito() {
      const modal = document.createElement("div");
      modal.className = "formulario-cotizacion-dulox-modal-overlay visible";
      modal.innerHTML = `
        <div class="formulario-cotizacion-dulox-modal mensaje-final">
          <h2 class="formulario-cotizacion-dulox-titulo">¡Gracias por tu solicitud!</h2>
          <p>Nos pondremos en contacto contigo pronto para enviarte la cotización.</p>
          <button class="formulario-cotizacion-dulox-boton" onclick="this.closest('.formulario-cotizacion-dulox-modal-overlay').remove(); document.documentElement.classList.remove('remove-scrolling')">Cerrar</button>
        </div>
      `;
      document.body.appendChild(modal);
    }
  }
});
